import {
  OnAnalyticsError,
  OnDisableAllTracking,
  OnDisableFacebookTracking,
  OnDisableGoogleTracking,
  OnDisableMixPanelTracking,
  OnInitMixPanel,
  OnInitTracking
} from './tracking.types'

export const ANALYTICS_ERROR = 'ANALYTICS_ERROR'
export const INIT_MIXPANEL = 'INIT_MIXPANEL'
export const TRACKING_INIT = 'TRACKING_INIT'
export const DISABLE_ALL_TRACKING = 'DISABLE_ALL_TRACKING'
export const DISABLE_FACEBOOK_TRACKING = 'DISABLE_FACEBOOK_TRACKING'
export const DISABLE_GOOGLE_TRACKING = 'DISABLE_GOOGLE_TRACKING'
export const DISABLE_MIXPANEL_TRACKING = 'DISABLE_MIXPANEL_TRACKING'

export const onInitMixPanel: OnInitMixPanel = (i18nProperties, mixPanelTracker) => ({
  payload: { i18nProperties, mixPanelTracker },
  type: INIT_MIXPANEL
})

export const onDisableAllTracking: OnDisableAllTracking = () => ({
  type: DISABLE_ALL_TRACKING
})
export const onDisableFacebookTracking: OnDisableFacebookTracking = () => ({
  type: DISABLE_FACEBOOK_TRACKING
})
export const onDisableGoogleTracking: OnDisableGoogleTracking = () => ({
  type: DISABLE_GOOGLE_TRACKING
})
export const onDisableMixPanelTracking: OnDisableMixPanelTracking = () => ({
  type: DISABLE_MIXPANEL_TRACKING
})

export const onAnalyticsError: OnAnalyticsError = error => ({
  payload: { error },
  type: ANALYTICS_ERROR
})

export const onInitTracking: OnInitTracking = (trackers) => ({
  payload: {
    trackers
  },
  type: TRACKING_INIT
})
